import React, { useEffect } from 'react'
import Helper from '../Helper'
import { APPLICATION_JSON } from '../../middleware/types';
import useStateRef from 'react-usestateref';


const ReviewSection = (props) => {

    return (<>{props && props.productId && props && props.dlProduct == false ? 
        <section class="col-12 accordion-item pdp-detail-reviews d-none" id="reviews">
            <h2 class="d-block d-md-none accordion-header" id="pdp-reviews-heading">
            <button  id="reviews_accordion_button" class="pdp accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#pdp-reviews-body" aria-expanded="true" aria-controls="pdp-reviews-body">
                    Reviews
                </button>
            </h2>

           

            <div id="pdp-reviews-body" class="accordionIsTablet accordion-collapse collapse" aria-labelledby="pdp-reviews-heading" data-bs-parent="#pdp-detail-accordion">
                <div class="accordion-body">
                <div data-bv-show="reviews" data-bv-product-id={props && props.productId}></div>
                   
                </div></div>
        </section> : ""}
    </>
    )
}

export default ReviewSection